$(document).ready(function() {
	if(!document.querySelector('.add-to-cart')) return false;
	var addToCart = {
		$nav: $('.navigation').eq(0),
		store: ($('.navigation').eq(0).data('store')) ? $('.navigation').eq(0).data('store') : 'default',
		form: "#addtocartForm",
		cookieName: 'LG5_CartID',
		cartID: null,
		url: ($('header.navigation') && $('header.navigation').data('cart-check')) ?  $('header.navigation').data('cart-check') : "/graphql",
		init: function() {
			// get cookie id
			addToCart.cartID = getCookie(addToCart.cookieName);
			if(addToCart.cartID) addToCart.getGNBCart();

			$('body').on({
				'ajaxLoadBefore':function(){
					//console.log('before load');
					$(this).append('<div class="loading-circle"><div class="lds-dual-ring"></div></div>');
				},
				'ajaxLoadEnd':function(){
					//console.log('check load');
					$(this).find('.loading-circle').remove();
				}
			});

			$('body').off('click.addtocart').on('click.addtocart', '.add-to-cart', function (e) {
				e.preventDefault();
				var modelId = $(this).data('model-id');

				$('body').trigger('ajaxLoadBefore');

				// adobe
				adobeTrackEvent('add-to-cart', {
					products: [{
						sales_model_code : findSalesModelCode($(this)),
						model_name: findModelName($(this)),
						value_added_to_cart: findPrice($(this)),
						units_added_to_cart: findModelCount($(this))
					}], page_event: {add_to_cart: true}
				});

				// get cookie id
				addToCart.cartID = getCookie(addToCart.cookieName);

				// create empty cart (obs)
				if(!addToCart.cartID) {
					addToCart.createEmptyCart(modelId);
				} else {
					// add to cart
					addToCart.addProductToCart(modelId, 1, addToCart.cartID);
				}

			});
		},
		checkLogin: function() {
			var isLogin = false;
			if(addToCart.$nav.find('.logged .after-login').length>0) {
				isLogin = true;
			}
			return isLogin;
		},
		getToken: function() {
			var authToken = '';
			if(addToCart.checkLogin()) {
				authToken = getCookie('ACCESS_TOKEN');
			}
			return authToken;
		},
		setCartNum: function(cnt) {
			if (cnt > 0) {
				if (cnt >= 100) {
					addToCart.$nav.find('.for-mobile .right .cart .count, .for-desktop .right-btm .icons .cart .count').html('99+');
				} else {
					addToCart.$nav.find('.for-mobile .right .cart .count, .for-desktop .right-btm .icons .cart .count').html(cnt);
				}
			} else {
				addToCart.$nav.find('.for-mobile .right .cart .count, .for-desktop .right-btm .icons .cart .count').html('');
			}
		},
		createEmptyCart: function(modelId) {
			var authToken = addToCart.getToken();
			var url = addToCart.url;
			var headers = {};
			if(authToken != '') {
				headers.Authorization = "Bearer " + authToken;
			}
			headers.Store = addToCart.store;
			headers["Content-type"] = "application/json";

			$.ajax({
				url: url,
				headers: headers,
				type: 'post',
				data: JSON.stringify({'query': 'mutation {createEmptyCart}', 'variables':null, 'operationName':null}),
				dataType: 'json',
				success: function(data) {
					addToCart.cartID = data.data.createEmptyCart;
					setCookie(addToCart.cookieName, addToCart.cartID);
					// add to cart
					addToCart.addProductToCart(modelId, 1, addToCart.cartID);
				},
				error: function(request, status, error) {
					//console.log("code:" + request.status + "\n" + "message:" + request.responseText + "\n" + "error:" + error);
				}
			});
		},
		addProductToCart: function(model, qty, cartid) {
			if(!model) return false;

			var authToken = addToCart.getToken();
			var url = addToCart.url;
			var headers = {};
			if(authToken != '') {
				headers.Authorization = "Bearer " + authToken;
			}
			headers.Store = addToCart.store;
			headers["Content-type"] = "application/json";

			$.ajax({
				url: url,
				headers: headers,
				type: 'post',
				data: JSON.stringify({'query': 'mutation { addModelToCart(input: { cart_id: "'+cartid+'", cartItems: [ { zipcode: "07632", data: { sku: "'+model+'", qty: '+qty+'} } ] }) { cart { items { product { sku } qty}}}}', 'variables':null, 'operationName':null}),
				dataType: 'json',
				success: function(data) {
					if(data.errors) {
						var errorMsg = '';
						for(var i=0;i<data.errors.length;i++) {
							errorMsg = errorMsg + data.errors[i].message;
						}
						//console.log(errorMsg);
						if($('#addToCartError').length>0) $('#addToCartError').remove();
						var html = '<div class="modal modal-simple fade" id="addToCartError" tabindex="-1" role="dialog" data-backdrop="false"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-body"><div class="simple-content-box"><div class="content-paragraph">'+errorMsg+'</div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal">Close</button></div></div></div></div>';

						$('body').append(html);
						$('#addToCartError').modal();
					} else {

						// GNB cart number +
						var items = data.data.addModelToCart.cart.items;
						var len = items.length;
						var cnt = 0;
						if(len>0) {
							for(var j=0;j<len;j++) {
								cnt = cnt + parseInt(items[j].qty);
							}
						}
						addToCart.setCartNum(cnt);

						// redirect case 추가할 것
					}
					$('body').trigger('ajaxLoadEnd');
				},
				error: function(request, status, error) {
					//console.log("code:" + request.status + "\n" + "message:" + request.responseText + "\n" + "error:" + error);
					$('body').trigger('ajaxLoadEnd');
				}
			});
		},
		getGNBCart: function() {
			// cart check
			var cartURL = addToCart.$nav.data('cart-check');
			var cartID = getCookie("LG5_CartID");
			if (cartURL && cartID) {
				var headers = {};
				headers.Authorization = "Bearer " + getCookie('ACCESS_TOKEN');
				headers.Store = addToCart.$nav.data('store');
				headers["Content-type"] = "application/json";

				$.ajax({
					url: cartURL,
					headers: headers,
					type: 'post',
					//type: 'get',
					data: JSON.stringify({'query': '{cart(cart_id: "'+cartID+'") { items { product {  sku name } qty } }}', 'variables':null, 'operationName':null}),
					dataType: 'json',
					success: function(data) {
						var len = data.data.cart.items.length;
						var cnt = 0;
						if(len>0) {
							for(var i=0;i<len;i++) {
								cnt = cnt + parseInt(data.data.cart.items[i].qty);
							}
							if (cnt > 0) {
								if (cnt >= 100) {
									addToCart.$nav.find('.for-mobile .right .cart .count, .for-desktop .right-btm .icons .cart .count').html('99+');
								} else {
									addToCart.$nav.find('.for-mobile .right .cart .count, .for-desktop .right-btm .icons .cart .count').html(cnt);
								}
							} else {
								addToCart.$nav.find('.for-mobile .right .cart .count, .for-desktop .right-btm .icons .cart .count').html('');
							}
						}
					},
					error: function(request, status, error) {
						//console.log("code:" + request.status + "\n" + "message:" + request.responseText + "\n" + "error:" + error);
					}
				});
			}
		}
	};
	addToCart.init();

});